import { bl_catalog_login_subject_link_import_file_hdr_RowClass } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';


export class CatalogLoginSubjectLinkFileHdrContainerModel extends BaseContainerModel {
  bl_catalog_login_subject_link_import_file_hdr: bl_catalog_login_subject_link_import_file_hdr_RowClass = new bl_catalog_login_subject_link_import_file_hdr_RowClass();
}
